import CheckBoxList from './CheckBoxList'
import {useEffect, useState} from 'react'
import {
    deepCopyObjectArray,
    isAllProvincesAreChecked, selectAllProvinces,
} from '../../services/util/miscellaneousService'

const TerritoriesCheckBoxList = ({territories, setTerritories}) => {
    const [canadaIsSelected, setCanadaIsSelected] = useState(false)
    const [allProvincesAreSelected, setAllProvincesAreSelected] = useState(false)

    useEffect(()=>{
        setCanadaIsSelected(territories[1].selected)
        setAllProvincesAreSelected(isAllProvincesAreChecked(territories))
    }, [territories])

    useEffect(()=>{
        const deepCopiedTerritories = deepCopyObjectArray(territories)
        deepCopiedTerritories[1].selected = allProvincesAreSelected
        setTerritories(deepCopiedTerritories)
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [allProvincesAreSelected])

    useEffect(()=>{
        const deepCopiedTerritories = deepCopyObjectArray(territories)
        if(canadaIsSelected){
            selectAllProvinces(deepCopiedTerritories)
        }
        setTerritories(deepCopiedTerritories)
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [canadaIsSelected])

    return (
        <CheckBoxList list={territories} setList={setTerritories} labelKey={'name'} />
    )
}

export default TerritoriesCheckBoxList